
const state = {
  // 首页数据
  orderNo:'',
}

const actions = {
}

const mutations = {
  get_order_no(state,data){
    state.orderNo = data;
  },
}

export default {
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/apply.js